const BASE = process.env.REACT_APP_BACKEND_URL;

export async function api(path, { method = "GET", body } = {}) {
  const res = await fetch(`${BASE}/api/pe${path}`, {
    method,
    credentials: "include",
    headers: body !== undefined ? { "Content-Type": "application/json" } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    /* empty response */
  }
  if (!res.ok) {
    const d = data && data.detail;
    const msg =
      typeof d === "string"
        ? d
        : Array.isArray(d)
          ? d.map((e) => (e && e.msg) || "").filter(Boolean).join(" ")
          : "Something went wrong. Please try again.";
    throw new Error(msg);
  }
  return data;
}

export const fmtMoney = (n) => (n === null || n === undefined ? "Quoted at consultation" : `$${Number(n).toFixed(n % 1 ? 2 : 0)}`);

export const fmtWhen = (iso) =>
  new Date(iso).toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
